var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "url(#paint0_linear_161_74)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 17.3346C17.333 16.4948 17.6666 15.6893 18.2605 15.0955C18.8544 14.5016 19.6598 14.168 20.4997 14.168H33.1663C33.5862 14.1681 33.9889 14.3349 34.2858 14.6319L42.2024 22.5486C42.4994 22.8454 42.6663 23.2481 42.6663 23.668V42.668C42.6663 43.5078 42.3327 44.3133 41.7388 44.9071C41.145 45.501 40.3395 45.8346 39.4997 45.8346H20.4997C19.6598 45.8346 18.8544 45.501 18.2605 44.9071C17.6666 44.3133 17.333 43.5078 17.333 42.668V17.3346ZM38.8442 23.668L33.1663 17.9901V23.668H38.8442ZM29.9997 17.3346H20.4997V42.668H39.4997V26.8346H31.583C31.1631 26.8346 30.7604 26.6678 30.4634 26.3709C30.1665 26.074 29.9997 25.6712 29.9997 25.2513V17.3346ZM23.6663 31.5846C23.6663 31.1647 23.8332 30.762 24.1301 30.465C24.427 30.1681 24.8297 30.0013 25.2497 30.0013H34.7497C35.1696 30.0013 35.5723 30.1681 35.8693 30.465C36.1662 30.762 36.333 31.1647 36.333 31.5846C36.333 32.0046 36.1662 32.4073 35.8693 32.7042C35.5723 33.0012 35.1696 33.168 34.7497 33.168H25.2497C24.8297 33.168 24.427 33.0012 24.1301 32.7042C23.8332 32.4073 23.6663 32.0046 23.6663 31.5846ZM23.6663 37.918C23.6663 37.498 23.8332 37.0953 24.1301 36.7984C24.427 36.5014 24.8297 36.3346 25.2497 36.3346H34.7497C35.1696 36.3346 35.5723 36.5014 35.8693 36.7984C36.1662 37.0953 36.333 37.498 36.333 37.918C36.333 38.3379 36.1662 38.7406 35.8693 39.0376C35.5723 39.3345 35.1696 39.5013 34.7497 39.5013H25.2497C24.8297 39.5013 24.427 39.3345 24.1301 39.0376C23.8332 38.7406 23.6663 38.3379 23.6663 37.918Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_74",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditServices);
export default __webpack_public_path__ + "static/media/AuditServices.7cc7e3fab091ba6fe7db8040b18aae34.svg";
export { ForwardRef as ReactComponent };